<router-outlet>
  <app-alert [message]="alertInfo?.message" *ngIf="alertInfo?.status"></app-alert>
</router-outlet>
